import React, { useEffect, useState } from 'react';
import { DataTable, Link } from '@shopify/polaris';
import { formatToCurrency, getDocPdfLinkForListViewIncoming, getRequest } from '../../../shared/components/functions';
import { useAuthStore } from '../../../context/useStore';

export default function InvoicesInCompany({ FIRNR }) {
  const { user } = useAuthStore();
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchItems = async () => {
      const data = await getRequest(`/api/invoices_in?limit=10000&FIRNR=${FIRNR}`);
      setItems(data);
    };

    fetchItems();
  }, [FIRNR]);

  const rows = Array.isArray(items)
    ? items.map((item) => {
        const payment_date = item.datumbetalingout ? String(item.datumbetalingout).substring(0, 10) : '';
        return [
          <Link removeUnderline url={'/invoices_in/' + item.faktuurinvolgnummer}>
            {item.FactuurInNummer}
          </Link>,
          getDocPdfLinkForListViewIncoming(item, item.supplier_number, item.FactuurInNummer, user, 'Factuur In', 'FI'),
          String(item.datumin).substring(0, 10),
          String(item.datumbetaling).substring(0, 10),
          String(item.datum).substring(0, 10),
          item.faktuurref,
          formatToCurrency(item.Bedragfaktuur),
          formatToCurrency(item.bedragopen),
          payment_date
          // <ApprovalBadges approvals={JSON.parse(item.approvals || '[]')} resource="invoice" />
        ];
      })
    : [];

  return items.length > 0 ? (
    <DataTable
      verticalAlign="middle"
      stickyHeader={true}
      increasedTableDensity={true}
      columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text', 'numeric', 'numeric', 'text']}
      headings={[<b>Number</b>, <b>PDF</b>, <b>Date in</b>, <b>Date expire</b>, <b>Date invoice</b>, <b>Reference</b>, <b>Value</b>, <b>Open</b>, <b>Date payment</b>]}
      rows={rows}
    />
  ) : (
    'No incoming invoices'
  );
}
